export const EVENT_BANNER_ADD_INIT = 'EVENT_BANNER_ADD_INIT'

export const EVENT_BANNER_UPDATE_INIT = 'EVENT_BANNER_UPDATE_INIT'

export const EVENT_BANNER_DETAIL_INIT = 'EVENT_BANNER_DETAIL_INIT'

export const EVENT_BANNER_DELETE_INIT = 'EVENT_BANNER_DELETE_INIT'

export const EVENT_BANNER_UPDATE_SUCCESS = 'EVENT_BANNER_UPDATE_SUCCESS'

export const EVENT_BANNER_SLIDE_ADD_INIT = 'EVENT_BANNER_SLIDE_ADD_INIT'

export const EVENT_BANNER_SLIDE_UPDATE_INIT = 'EVENT_BANNER_SLIDE_UPDATE_INIT'

export const EVENT_BANNER_SLIDE_DETAIL_INIT = 'EVENT_BANNER_SLIDE_DETAIL_INIT'

export const EVENT_BANNER_SLIDE_DELETE_INIT = 'EVENT_BANNER_SLIDE_DELETE_INIT'

export const EVENT_BANNER_SLIDE_UPDATE_SUCCESS = 'EVENT_BANNER_SLIDE_UPDATE_SUCCESS'